import React from "react";
import { NavLink as Link } from "react-router-dom";
import { Nav, NavLink, NavProps } from "reactstrap";
import keycloak from "../../keycloak";
import {
  UrlPathBlockCustomer,
  UrlPathBonifiedInteractions,
  UrlPathCoupon,
  UrlPathCustomer,
  UrlPathCustomerPreferences,
  UrlPathInviteFamily,
  UrlPathInviteFriend,
  UrlPathMain,
  UrlPathReceipts,
  UrlPathSimulator,
  UrlPathGameZone,
  UrlPathMissionCenter,
} from "../../url";

const keycloakAccountUrl = () => {
  const base = window.env.REACT_APP_KEYCLOAK_URL || process.env.REACT_APP_KEYCLOAK_URL;
  if (!base) return "";
  return `${base}/realms/${keycloak.realm}/account/account-security/signing-in`;
};

export default class Menu extends React.Component<NavProps> {
  render() {
    return (
      <Nav {...this.props}>
        <NavLink
          tag={Link}
          to={UrlPathCustomer}
          className={
            globalThis.location.pathname === UrlPathMain || globalThis.location.pathname === UrlPathCustomer ? "active" : ""
          }
        >
          Mein Profil
        </NavLink>
        <NavLink href={keycloakAccountUrl()} target="_blank" rel="noopener noreferrer">
          Kennwort
        </NavLink>
        <NavLink tag={Link} to={UrlPathBlockCustomer}>
          Karte sperren
        </NavLink>
        <NavLink tag={Link} to={UrlPathCustomerPreferences}>
          Vorlieben
        </NavLink>
        <NavLink tag={Link} to={UrlPathBonifiedInteractions}>
          Bonuspunkte
        </NavLink>
        <NavLink tag={Link} to={UrlPathCoupon}>
          Meine Coupons
        </NavLink>
        <NavLink tag={Link} to={UrlPathSimulator}>
          Shop
        </NavLink>
        <NavLink tag={Link} to={UrlPathMissionCenter}>
          Mission Center
        </NavLink>
        <NavLink tag={Link} to={UrlPathGameZone}>
          GameZone
        </NavLink>
        <NavLink tag={Link} to={UrlPathInviteFamily}>
          Familie
        </NavLink>
        <NavLink tag={Link} to={UrlPathInviteFriend}>
          Freunde
        </NavLink>
        <NavLink tag={Link} to={UrlPathReceipts}>
          Meine Bons
        </NavLink>
      </Nav>
    );
  }
}
